(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Alpha Wildclaw": { auraUntargetable: { scope: "here", lessMightThanSource: true } },

    "Back Off": {
      play: [
        { op: "stun", to: "$t1" },
        { op: "if", cond: { k: "fromHand" }, then: [{ op: "draw", n: 1 }] },
      ],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Stun..." }],
    },

    "Enthusiastic Promoter": {
      triggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, [Buff] all units here",
          targets: [],
          program: [{ op: "buff", spec: { type: "unit", here: true } }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Frisky Hunter": {
      play: [{ op: "token", name: "Bird", n: 1, loc: "here", exhausted: false }],
    },

    "Herald of Spring": { play: [{ op: "xp", n: 2 }] },

    "Mosstomper": {
      selfMightSpecs: [{ n: 1, cond: { k: "xp", n: 3 } }],
      selfKwSpecs: [{ name: "deflect", value: null, cond: { k: "xp", n: 3 } }],
    },

    "Mutated Mouser": {},

    "Soul Sword": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["calm"] }),
      ],
      attachedMightSpecs: [{ n: 1, cond: { k: "xp", n: 3 } }],
    },

    "Trevor Snoozebottom": {
      triggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, play a ready 3 :rb_might: Sprite unit token with [Temporary] here",
          targets: [],
          program: [
            { op: "token", name: "Sprite", n: 1, loc: "here", exhausted: false, ready: true },
          ],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Wuju Apprentice": {
      play: [{ op: "if", cond: { k: "xp", n: 6 }, then: [{ op: "draw", n: 1 }] }],
    },

    "Wuju Master": {
      auraMightSpecs: [{ n: 1, cond: { k: "xp", n: 6 }, who: "friendlyUnits" }],
      auraEntersReadyCond: { k: "xp", n: 11 },
    },

    "Yuumi, Magical Cat": {
      triggers: [
        {
          on: "attack",
          optional: false,
          label: "When I attack or defend, give one of your other units here +3 :rb_might: and [Tank] this turn",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", friendly: true, other: true, here: true },
              prompt: "Give +3 Might and [Tank] to...",
            },
          ],
          program: [{ op: "grant", to: "$t1", might: 3, dur: "turn", keyword: "tank" }],
          self: true,
        },
        {
          on: "defend",
          optional: false,
          label: "When I attack or defend, give one of your other units here +3 :rb_might: and [Tank] this turn",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", friendly: true, other: true, here: true },
              prompt: "Give +3 Might and [Tank] to...",
            },
          ],
          program: [{ op: "grant", to: "$t1", might: 3, dur: "turn", keyword: "tank" }],
          self: true,
        },
      ],
    },

    "Combat Experience": {
      targets: [{
        bind: "t",
        spec: { type: "unit" },
        prompt: "Give which unit +1 :rb_might: this turn?",
      }],
      play: [{
        op: "if",
        cond: { k: "xp", n: 6 },
        then: [buff("$t", 3)],
        else: [buff("$t", 1)],
      }],
    },

    "Double Trouble": {
      play: [{
        op: "lookTopTake",
        n: 3,
        optional: true,
        public: true,
        take: "hand",
        filter: { type: "unit" },
        prompt: "Reveal a unit from among the top 3 and draw it (choose none to recycle all 3)",
      }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Monch": {
      costMods: [{ energyLess: 2, cond: { k: "oppStunnedUnit" } }],
      entersReadyCond: { k: "oppStunnedUnit" },
    },

    "Skyward Strike": {
      targets: [{
        bind: "t",
        spec: { type: "unit", enemy: true },
        prompt: "Move which enemy unit?",
      }],
      play: [
        { op: "move", to: "$t" },
        {
          op: "if",
          cond: { k: "xp", n: 6 },
          then: [
            {
              op: "choose",
              bind: "s",
              spec: { type: "unit", enemy: true },
              prompt: "[Level 6]: [Stun] which enemy unit?",
            },
            { op: "stun", to: "$s" },
          ],
        },
      ],
    },

    "Allay, Eager Admirer": {
      auraKwSpecs: [{ name: "deflect", value: 1, scope: "hereBf", excludeSelf: true }],
    },

    "Flurry of Feathers": {
      play: [
        {
          op: "option",
          varKey: "mode",
          prompt: "Choose one",
          options: ["Counter a spell", "Play four 1 :rb_might: Bird tokens with [Deflect]"],
        },
        {
          op: "if",
          cond: { k: "varEq", key: "mode", value: 0 },
          then: [
            {
              op: "choose",
              bind: "c",
              spec: { zone: "chain", type: "spell" },
              prompt: "Counter which spell?",
            },
            { op: "counter", to: "$c" },
          ],
          else: [{ op: "token", name: "Bird", n: 4 }],
        },
      ],
    },

    "Forgotten Signpost": {
      abilities: [{
        label: "Exhaust a unit you control, :rb_exhaust:: move a different unit you control to its location",
        exhausts: true,
        action: true,
        targets: [
          {
            bind: "e",
            spec: { type: "unit", friendly: true, ready: true },
            prompt: "Exhaust which unit you control to pay for this?",
          },
          {
            bind: "m",
            spec: { type: "unit", friendly: true, notBind: "e" },
            prompt: "Move which other unit you control to its location?",
          },
        ],
        program: [
          { op: "exhaust", to: "$e" },
          { op: "move", to: "$m", destRef: "$e" },
        ],
      }],
    },

    "Friendship": {
      targets: [{
        bind: "t",
        spec: { type: "unit" },
        prompt: "Give which unit +1 :rb_might: per Bird, Cat, Dog and Poro among your units?",
      }],
      play: [
        { op: "if", cond: { k: "controlsTag", tag: "Bird" }, then: [buff("$t", 1)] },
        { op: "if", cond: { k: "controlsTag", tag: "Cat" }, then: [buff("$t", 1)] },
        { op: "if", cond: { k: "controlsTag", tag: "Dog" }, then: [buff("$t", 1)] },
        { op: "if", cond: { k: "controlsTag", tag: "Poro" }, then: [buff("$t", 1)] },
      ],
    },

    "Honeyfruit": {
      entersExhausted: true,
      abilities: [{
        label: "[Add] :rb_rune_rainbow: (:rb_energy_1::rb_rune_rainbow: while you have 6+ XP)",
        exhausts: true,
        reaction: true,
        isAdd: true,
        targets: [],
        program: [
          { op: "addResources", res: { energy: 0, pips: 0, anyPower: 1, domains: null } },
          {
            op: "if",
            cond: { k: "xp", n: 6 },
            then: [{ op: "addResources", res: { energy: 1, pips: 0, anyPower: 0, domains: null } }],
          },
        ],
      }],
    },

    "Iascylla": {
      triggers: [{
        on: "unitHold",
        self: true,
        optional: false,
        label: "hold: at the start of your next Main Phase, move an enemy unit here",
        targets: [],
        program: [{
          op: "delayed",
          on: "mainPhase",
          forPlayer: "controller",
          label: "Iascylla: move an enemy unit to this battlefield",
          program: [
            { op: "if", cond: { k: "selfAtBf" }, skip: 2 },
            {
              op: "choose",
              bind: "_iu",
              spec: { type: "unit", enemy: true, otherLoc: true },
              min: 0,
              max: 1,
              prompt: "Move an enemy unit to Iascylla's battlefield (choose none to decline)",
            },
            { op: "move", to: "$_iu", destRef: "source" },
          ],
        }],
      }],
    },

    "Ivern, Nurturer": {
      play: [
        {
          op: "lookTopTake",
          n: 3,
          optional: true,
          public: true,
          take: "hand",
          bind: "iv",
          filter: { type: "unit" },
          prompt: "Reveal a unit from among the top 3 and draw it (choose none to recycle all 3)",
        },
        {
          op: "if",
          cond: {
            k: "or",
            conds: [
              { k: "targetTag", bind: "iv", tag: "Bird" },
              { k: "targetTag", bind: "iv", tag: "Cat" },
              { k: "targetTag", bind: "iv", tag: "Dog" },
              { k: "targetTag", bind: "iv", tag: "Poro" },
            ],
          },
          then: [
            {
              op: "choose", bind: "ib", spec: { type: "unit", friendly: true },
              prompt: "Buff which friendly unit?",
            },
            { op: "buff", to: "$ib" },
          ],
        },
      ],
      triggers: [{
        on: "unitHold",
        self: true,
        optional: false,
        label: "hold: look at the top 3 for a unit",
        targets: [],
        program: [
          {
            op: "lookTopTake",
            n: 3,
            optional: true,
            public: true,
            take: "hand",
            bind: "iv",
            filter: { type: "unit" },
            prompt: "Reveal a unit from among the top 3 and draw it (choose none to recycle all 3)",
          },
        {
          op: "if",
          cond: {
            k: "or",
            conds: [
              { k: "targetTag", bind: "iv", tag: "Bird" },
              { k: "targetTag", bind: "iv", tag: "Cat" },
              { k: "targetTag", bind: "iv", tag: "Dog" },
              { k: "targetTag", bind: "iv", tag: "Poro" },
            ],
          },
          then: [
            {
              op: "choose", bind: "ib", spec: { type: "unit", friendly: true },
              prompt: "Buff which friendly unit?",
            },
            { op: "buff", to: "$ib" },
          ],
        },
        ],
      }],
    },

    "Nami, Headstrong": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Nami, Headstrong",
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["calm"] },
        then: [{ op: "stun", to: "$_ns" }],
        thenTargets: [{
          bind: "_ns",
          spec: { type: "unit", enemy: true },
          prompt: "[Stun] which enemy unit?",
        }],
      }],
      triggers: [{
        on: "unitHold",
        self: true,
        optional: false,
        label: "hold: ready and buff the next unit you play this turn",
        targets: [],
        program: [{
          op: "delayed",
          on: "played",
          forPlayer: "controller",
          label: "Nami, Headstrong: ready and [Buff] it",
          program: [
            { op: "if", cond: { k: "evType", type: "unit" }, skip: 2 },
            { op: "ready", to: "$ev" },
            { op: "buff", to: "$ev" },
          ],
        }],
      }],
    },

    "Scuttle Crab": {
      play: [{ op: "draw", n: 1 }],
      deathknell: [
        { op: "revealHand", who: "opponent", lookFacedown: true },
        { op: "xp", n: 1 },
      ],
    },

    "Lillia, Protector of Dreams": {
      auraKwSpecs: [{ name: "tank", value: null, targetCond: { k: "selfToken" } }],
      triggers: [{
        on: "played", you: true,
        label: "you play a token unit: give me +1 Might this turn",
        condSpec: { k: "and", conds: [{ k: "evToken" }, { k: "evType", type: "unit" }] },
        program: [buff("source", 1)],
      }],
    },

    "Master Yi, Unstoppable": {
      costMods: [
        {
          cond: { k: "and", conds: [{ k: "xp", n: 3 }, { k: "not", cond: { k: "xp", n: 6 } }] },
          energyLess: 2,
          powerLess: 1,
        },
        {
          cond: { k: "and", conds: [{ k: "xp", n: 6 }, { k: "not", cond: { k: "xp", n: 11 } }] },
          energyLess: 4,
          powerLess: 2,
        },
        {
          cond: { k: "xp", n: 11 },
          energyLess: 6,
          powerLess: 3,
        },
      ],
      selfUntargetable: true,
      selfUntargetableCond: { k: "xp", n: 16 },
    },

    "Vilemaw": {
      auraNoCombatDamage: [{ who: "enemy", scope: "here", lessMightThanSource: true }],
      triggers: [{
        on: "unitHold",
        self: true,
        optional: false,
        label: "hold: draw 1",
        targets: [],
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Bashful Bloom": {
      abilities: [{
        cost: { energy: 4, pips: 0, anyPower: 0, domains: null },
        exhausts: true,
        label: "Bashful Bloom",
        targets: [],
        program: [{ op: "token", name: "Sprite", ready: true }],
      }],
      auraCostMod: [{
        ability: { label: "Bashful Bloom", type: "legend" },
        energyLess: { count: { type: "unit", friendly: true, hasKw: "temporary", ignoreUntargetable: true } },
      }],
    },

    "Lilting Lullaby": {
      targets: [{ bind: "t", spec: { zone: "chain", type: "spell", counterable: true }, prompt: "Counter which spell?" }],
      play: [
        { op: "counter", to: "$t" },
        { op: "restrictPlay", who: "countered", banType: "spell", dur: "turn" },
      ],
    },

    "Alpha Strike": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Which friendly unit deals its Might?" }],
      play: [
        {
          op: "delayed", on: "dies", dur: "turn", repeat: true, expiresThisTurn: true,
          condSpec: { k: "evKilledByMySpell" },
          label: "Alpha Strike killed a unit: gain 1 XP",
          program: [{ op: "xp", n: 1 }],
        },
        {
          op: "splitDamage",
          n: { mightOf: "$t" },
          spec: { type: "unit", enemy: true, atBf: true },
          prompt: "Split the damage among enemy units at battlefields",
        },
      ],
    },

    "Gloomist": {
      triggers: [{
        on: "hold",
        you: true,
        optional: true,
        exhaustSelf: true,
        label: "hold: exhaust me to draw 1",
        condSpec: { k: "selfReady" },
        program: [
          { op: "exhaust", to: "source" },
          { op: "draw", n: 1 },
        ],
      }],
    },

    "Shadow": {
      entersReadyCond: { k: "selfAtBf" },
      abilities: [{
        cost: { energy: 1, pips: 0, anyPower: 1, domains: null },
        exhausts: true,
        action: true,
        needBf: true,
        label: "Shadow",
        targets: [{
          bind: "t",
          spec: { type: "unit", enemy: true, here: true, attacking: true },
          prompt: "Stun which enemy unit attacking here?",
        }],
        program: [{ op: "stun", to: "$t" }],
      }],
    },

    "Daisy!": {
      entersReady: true,
      costMods: [
        { energyLess: 1, cond: { k: "count", spec: { type: "unit", friendly: true, tag: "Bird", ignoreUntargetable: true } } },
        { energyLess: 1, cond: { k: "count", spec: { type: "unit", friendly: true, tag: "Cat", ignoreUntargetable: true } } },
        { energyLess: 1, cond: { k: "count", spec: { type: "unit", friendly: true, tag: "Dog", ignoreUntargetable: true } } },
        { energyLess: 1, cond: { k: "count", spec: { type: "unit", friendly: true, tag: "Poro", ignoreUntargetable: true } } },
      ],
      triggers: [{
        on: "attack",
        self: true,
        label: "attack with all four tags: stun an enemy unit here",
        condSpec: {
          k: "and",
          conds: [
            { k: "count", spec: { type: "unit", friendly: true, tag: "Bird", ignoreUntargetable: true } },
            { k: "count", spec: { type: "unit", friendly: true, tag: "Cat", ignoreUntargetable: true } },
            { k: "count", spec: { type: "unit", friendly: true, tag: "Dog", ignoreUntargetable: true } },
            { k: "count", spec: { type: "unit", friendly: true, tag: "Poro", ignoreUntargetable: true } },
          ],
        },
        targets: [{ bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Stun which enemy unit here?" }],
        program: [{ op: "stun", to: "$t" }],
      }],
    },

    "Green Father": {
      triggers: [
        {
          on: "conquer", you: true, optional: true, exhaustSelf: true, condSpec: { k: "selfReady" },
          label: "conquered: exhaust me to replace that battlefield with Brush",
          program: [{ op: "exhaust", to: "source" }, { op: "replaceBf", bfFromEvent: true, card: "Brush" }],
        },
        {
          on: "hold", you: true, optional: true, exhaustSelf: true, condSpec: { k: "selfReady" },
          label: "held: exhaust me to replace that battlefield with Brush",
          program: [{ op: "exhaust", to: "source" }, { op: "replaceBf", bfFromEvent: true, card: "Brush" }],
        },
      ],
    },

    "Shadow Watcher": {
      entersReadyCond: { k: "turnFact", key: "unitDiedBeginning", n: 1 },
    },

    "Tricksy Tentacles": {
      play: [
        {
          op: "chooseBudget", bind: "t", n: 8, sameController: true,
          spec: { type: "unit", enemy: true },
          prompt: "Move which enemy units (one controller, total Might 8 or less)?",
        },
        { op: "move", to: "$t" },
      ],
    },

    "Vex, Mocking": {
      triggers: [{
        on: "stunned", you: true, optional: true,
        label: "you stun an enemy unit at a battlefield: move me there",
        condSpec: { k: "and", conds: [{ k: "evEnemy" }, { k: "evAtBf" }, { k: "evOther" }] },
        program: [{ op: "move", to: "source", destRef: "$ev" }],
      }],
    },
  });
})();
